import { Component, Input, OnInit } from '@angular/core';
import { Image } from '../../interfaces/image';

@Component({
  selector: 'app-image-grid',
  templateUrl: './image-grid.component.html',
  styleUrls: ['./image-grid.component.scss']
})
export class ImageGridComponent implements OnInit {
  @Input() imageCenter: Image;
  @Input() imageLeftTop: Image;
  @Input() imageLeftBottom: Image;
  @Input() imageRight: Image;

  constructor() { }

  ngOnInit() {
  }

}
